import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { KeycloakService } from "keycloak-angular";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../common/loading/loading.component";
import { ConfigService } from "../../../core/services/config/config.service";
import { RestService } from "../../../core/services/rest.service";
import { ToasterService } from "../../../core/services/toaster-service";

@Component({
  selector: "app-delete-caution-modal",
  standalone: true,
  imports: [CommonModule, ZorroTableComponent, LoadingComponent],
  templateUrl: "./delete-caution-modal.component.html",
  styleUrl: "./delete-caution-modal.component.scss",
})
export class DeleteCautionModalComponent {
  activeModal = inject(NgbActiveModal);

  @Input()
  configs: {
    title?: string;
    cautionMessage1?: string;
    cautionMessage2?: string;
    footerMessage1?: string;
    footerMessage2?: string;
    subTitle?: string;
    tableData?: any;
    tableTitle?:string,
    columns?: any;
    failedCount?: any;
    description?: any;
    deleteButtonText?:string;
    projectId?: string;
    automationProjectId?: string;
  } = {};
  columns: any;
  tableData: any;
  isLoading: boolean = false;

  private readonly configService = inject(ConfigService);

  constructor(
    public keycloakService: KeycloakService,
    private readonly restService: RestService,
    private readonly toaster: ToasterService
  ) {}

  ngOnInit() {
    this.columns = this.configs.columns;
    this.tableData = this.configs.tableData;
  }

  handleTableActions(event: any) {
    switch (event?.type) {
      case "conditional-button":
       this.restService.getEditorStatus(this.configs?.projectId as string, this.configs?.automationProjectId as string, event?.data?.row?.script?.id as string).subscribe({
          next: (response) => {
            if (response?.data?.canOpen) {
              this.setEditorOpenedStatus(this.configs?.projectId as string, this.configs?.automationProjectId as string, event?.data?.row?.script?.id as string);
              const scriptUrl = this.configService.buildAppUrl(
                `project/${this.configs?.projectId}/automation/${this.configs?.automationProjectId}/script/${event?.data?.row?.script?.id}/editor-view`
              );
              window.open(scriptUrl, "_blank");
            } else {
              this.toaster.pop({ type: 'warning', text: response?.data?.message });
              this.setEditorOpenedStatus(this.configs?.projectId as string, this.configs?.automationProjectId as string, event?.data?.row?.script?.id as string);
            }
          },
          error: (error) => {
            console.error("Error checking editor status:", error);
          }
        });
        break;

      default:
        break;
    }
  }

   setEditorOpenedStatus(projectId: string, automationProjectId: string, scriptId: string) {
    this.restService.setEditorOpenStatus(projectId, automationProjectId, scriptId).subscribe({
      next: (response) => {
        console.log(response);
      },
      error: (error) => {
        console.error("Error setting editor status:", error);
      }
    });
  }

}
